import SprievodnyDokument from '../../../../model/legislativnyMaterial/SprievodnyDokument';
import { ClientStatus } from '../../../../model/ClientStatus';
import { useClientFetch } from '../../../../context/ClientStatusContext';
import {
  fetchSprievodnyDokumentList,
} from '../../../../client/external/evidencnaaplikacia/sprievodnyDokumentListClient';

interface ReturnType {
  sprievodnyDokumentList: Array<SprievodnyDokument>;
  sprievodnyDokumentStatus: ClientStatus;
}

export default (legMaterialuuid: string, stadiumUuid: string): ReturnType => {
  const {
    data: sprievodnyDokumentList,
    status: sprievodnyDokumentStatus,
  } = useClientFetch(
    fetchSprievodnyDokumentList,
    [legMaterialuuid, stadiumUuid],
    [stadiumUuid],
  );
  return {
    sprievodnyDokumentList,
    sprievodnyDokumentStatus,
  };
};
